import { Product } from "@/gen/product_without_validate_connect";
import { createPromiseClient } from "@connectrpc/connect"
import defaultTransport from "./transport"

const productClient = createPromiseClient<typeof Product>(Product, defaultTransport);

export default productClient;